import { useQuery } from '@tanstack/react-query';
import { fetchLookupRegions } from '@api';
import { REGION_TYPES } from '@constants';

function sortRegions(a, b) {
  if (a.name < b.name) {
    return -1;
  }
  if (a.name > b.name) {
    return 1;
  }
  return 0;
}

export const useLookupRegionsQuery = () => {
  return useQuery({
    queryKey: ['lookupRegions'],
    placeholderData: [],
    queryFn: ({ signal }) => {
      return fetchLookupRegions({ regionTypes: [REGION_TYPES.COMMERCIAL_REGIONS_SHIPS] }, signal)
        .then((resp) => resp.sort(sortRegions))
        .catch(() => []);
    }
  });
};
